import Admin from 'hive-admin';

import stores from './pages/stores';
import sales from './pages/sales';
import orders from './pages/orders';
import products from './pages/products';
import locations from './pages/locations';

// import tests from '../../helpers/tests';

// const { viewerIsNotAdmin } = tests;

export default Admin.compileFromLibrary(['Group', {
  id: 'statistics',
  title: 'Statistics',
  icon: 'area-chart',
  redirect: [['redirect.unauthorized']],
  // hidden: [
  //   viewerIsNotAdmin,
  // ],
  // skip: [
  //   props => (
  //     !props.viewer
  //     || props.viewer.role !== 'ADMIN'
  //   ),
  // ],
  pages: [
    stores,
    sales,
    orders,
    products,
    locations,
  ].map(([pageComponentName, pageConfig = {}]) => (
    [pageComponentName, {
      ...pageConfig,
      createButtonSupported: false,
    }]
  )),
}]).pages;
